module.exports = __webpack_public_path__ + "static/media/logo.fc9b45ad.svg";